import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  CheckIn,
  CheckInFailure,
  CheckInFeatureActionTypes,
  CheckInSuccess,
} from './check-in-kiosk-feature-check-in.actions';
import { CheckInKioskFeatureCheckInService } from './check-in-kiosk-feature-check-in.service';

@Injectable()
export class CheckInKioskFeatureCheckInEffects {
  checkIn$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckInFeatureActionTypes.CheckIn),
      mergeMap(({ payload }: CheckIn) =>
        this.srv.checkIn(payload).pipe(
          map(() => new CheckInSuccess()),
          catchError((error) => of(new CheckInFailure(error)))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private srv: CheckInKioskFeatureCheckInService
  ) {}
}
